import { Question } from '@phosphor-icons/react';

// ナレッジ記事を唯一の入口にする。検索から来ても、画面の「?」から来ても、
// まずこの記事に着地し、記事内のリンクからガイド本体へ進む。
export const GUIDE_KB_SLUG = 'development-project-guide-ts39';
export const DEV_GUIDE_PATH = '/engineering/developments/guide';
export const GUIDE_KB_PATH = `/knowledge/p/${GUIDE_KB_SLUG}`;

/** 案件名の横に置く小さな「?」。ナレッジの使い方記事を別タブで開く。 */
export const GuideHelpButton = ({ testid = 'dev-guide-help-btn' }) => (
  <a href={GUIDE_KB_PATH} target="_blank" rel="noopener noreferrer"
    title="開発案件の使い方 / How to use Development Project"
    aria-label="開発案件の使い方 / How to use Development Project"
    data-testid={testid}
    onClick={(e) => e.stopPropagation()}
    className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-zinc-300 bg-white text-zinc-500 transition-colors hover:border-teal-500 hover:text-teal-700">
    <Question size={14} weight="bold" />
  </a>
);
